module.exports = {
          srcSet: __webpack_public_path__ + "aeaf9f8c7bd707047e86551c7c74c331-488.png"+" 488w",
          images:[ {path: __webpack_public_path__ + "aeaf9f8c7bd707047e86551c7c74c331-488.png",width: 488,height: 489}],
          src: __webpack_public_path__ + "aeaf9f8c7bd707047e86551c7c74c331-488.png",
          toString:function(){return __webpack_public_path__ + "aeaf9f8c7bd707047e86551c7c74c331-488.png"},
          
          width: 488,
          height: 489
        }